module.exports = __webpack_public_path__ + "static/assets/e00fc123975e2ffbee5d186e6e205358.png";